import { EmptyStateArt, emptyStateArt } from '@/assets/empty-states'
import React from 'react'
import {
	EmptyStateActions,
	EmptyStateArtwork,
	EmptyStateBlock,
	EmptyStateContainer,
	EmptyStateDescription,
	EmptyStateTitle,
} from './EmptyState.styles'

interface EmptyStateProps {
	/** Which drawing from the shared zero-state art set to show. */
	art: EmptyStateArt
	title: string
	/** The line under the title explaining what lands here once it isn't empty. */
	description?: string
	/**
	 * `page` (default) centers the zero-state in the page's free space; `panel`
	 * scales it down for an inset section panel, e.g. the balances activity feed.
	 */
	variant?: 'page' | 'panel'
	/** CTA buttons — use the exported `EmptyStateButton`. Omit for read-only surfaces. */
	children?: React.ReactNode
}

/**
 * The one zero-state every section page renders: gold line art over a title,
 * a friendly line, and the page's CTAs, centered in the page's free space.
 * One atom so the member pages, the public mirrors, and the trips list can't
 * drift into six different empty layouts.
 */
const EmptyState: React.FC<EmptyStateProps> = ({ art, title, description, variant = 'page', children }) => {
	const Art = emptyStateArt[art]
	const panel = variant === 'panel'

	return (
		<EmptyStateContainer $panel={panel}>
			<EmptyStateBlock>
				<EmptyStateArtwork $panel={panel} aria-hidden="true">
					<Art />
				</EmptyStateArtwork>
				<EmptyStateTitle $panel={panel}>{title}</EmptyStateTitle>
				{description && <EmptyStateDescription>{description}</EmptyStateDescription>}
				{children && <EmptyStateActions>{children}</EmptyStateActions>}
			</EmptyStateBlock>
		</EmptyStateContainer>
	)
}

export default EmptyState
